// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_lXIpN){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_28Vlg .dualColumn_Ja4Z1{display:flex;align-content:space-between}.nsAddressForm_28Vlg .dualColumn_Ja4Z1 .firstCol_XI2Ux{margin-right:20px}.optional_3GsJ2{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_lXIpN",
	"nsAddressForm": "nsAddressForm_28Vlg",
	"dualColumn": "dualColumn_Ja4Z1",
	"firstCol": "firstCol_XI2Ux",
	"optional": "optional_3GsJ2"
};
module.exports = exports;
